import {type CardEnum, type CardStateUnordered} from '@colonist/game-states'
import {BaseCardValidator} from './BaseCardValidator.ts'
import {isValueNullish, isValueNumber} from '@colonist/validation'

export class CardValidatorUnordered extends BaseCardValidator<CardStateUnordered> {
    get cards(): CardEnum[] {
        const cards: CardEnum[] = []
        for(const card in this.state) {
            const numberOfCards = this.state[card]

            if(!CardValidatorUnordered.isCardCountValid(numberOfCards)) continue
            if(numberOfCards == 0) continue

            const cardType = Number(card)
            if(typeof cardType != 'number') continue

            cards.push(...Array(numberOfCards).fill(cardType))
        }
        return cards
    }

    private static isCardCountValid(numberOfCards: number | undefined): boolean {
        if(isValueNullish(numberOfCards)) return false
        if(!isValueNumber(numberOfCards)) return false
        return true
    }
}
